import type { FC } from "react";

import { Button } from "@jti/core-components/components/Button";
import type { AddressStored } from "@jti/fe-common";
import { AddressInfoBlock } from "@jti/ui/components/AddressInfoBlock";

import styles from "./AddressCard.module.scss";

export type AddressCardProps = {
  title?: string;
  address: AddressStored;
  editButtonLabel?: string;
  onEdit?: (addressId: string) => void;
};

export const AddressCard: FC<AddressCardProps> = ({ address, onEdit, editButtonLabel = "Edit", title }) => {
  const handleEditAddress = () => {
    if (!onEdit) {
      return;
    }
    onEdit(address.id);
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleSection}>
        <h4 className={styles.title}>{title}</h4>
        {onEdit && (
          <Button variant="text" onClick={handleEditAddress}>
            {editButtonLabel}
          </Button>
        )}
      </div>
      <AddressInfoBlock address={address} />
    </div>
  );
};
